import { Grid, Stack, useMediaQuery, useTheme } from "@mui/material"
import { useSelector } from "react-redux"
import GameFactIcon_Dsas from "../../../dsasComponents/GameFactIcon_Dsas.js"

import gameFacts from "./gamefacts.js"
import { useMemo } from "react"

//TODO GF filters save GF with proper ID step
const GameFactFilter = ({match, enterGameFact, surchargePeriod}) => {

    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    const gameFactsToUse = useMemo(() => {       
        return gameFacts.filter(g => g.discipline === match.discipline && g.pos && g.show && g.show.includes(surchargePeriod))
    }, [surchargePeriod])

    const [col1, col2] = useMemo(() => {

        const [col1, col2] = gameFactsToUse.reduce((acc,curr) => {
            const {pos} = curr
            if(pos[0] === 0){
                acc[0].push(curr)
            }else{
                acc[1].push(curr)
            }
    
            return acc
    
        }, [[], []])

        col1.sort((a, b) => a.pos[1] - b.pos[1])
        col2.sort((a, b) => a.pos[1] - b.pos[1])


        return [col1, col2]
    }, [gameFactsToUse])
    

    

    return  <Grid container direction={"row"} sx={{paddingTop : 1}}>

                {isSmall ? <Grid item xs={12}>
                        {[...col1, ...col2].map((g, idx) => idx).map(idx => { let gameFact = idx%2===0 ? col1[idx/2] : col2[((idx-1)/2)]; return <GameFactIcon_Dsas src={gameFact.img} onClick={() => enterGameFact(gameFact.id)}/>})}
                </Grid>
                : 
                <><Grid item xs={12} sm={6}>
                        {col1.map(g => <GameFactIcon_Dsas key={g.id} id={g.id} src={g.img} onClick={() => enterGameFact(g.id)}/>)}
                </Grid>
                <Grid item xs={12} sm={6}>
                        {/*key --> only for React's internal use and can't be used within the child component*/}
                        {col2.map(g => <GameFactIcon_Dsas key={g.id} id={g.id} src={g.img} onClick={() => enterGameFact(g.id)}/>)}
                </Grid></>}
            </Grid>
}

export default GameFactFilter